import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

export const Container = styled.div<{ $caption: boolean }>`
  padding: 0 20px 88px;

  @media ${breakpoints.tablet} {
    padding: 0 calc(1 / 12 * 100vw) 88px;
  }

  @media ${breakpoints.laptop} {
    padding: 0 calc(1 / 12 * 100vw) 163px;
    ${({ $caption }) => ($caption ? "padding-bottom: 145px;" : "")}
  }
`

export const Content = styled.div`
  position: relative;
  width: 100%;
  height: calc((100vw - 40px) * 0.56);

  @media ${breakpoints.laptop} {
    width: calc(10 / 12 * 100vw);
    height: calc(10 / 12 * 100vw * 0.5625);
  }

  video {
    &:focus {
      outline: none;
    }
  }
`

const IFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`

const CaptionWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
`

const Caption = styled.div`
  width: calc(100% - 35px);
  font-family: "Avenir Roman";
  font-size: 15px;
  color: ${colors.black};
  line-height: 22px;
  opacity: 0.3;

  @media ${breakpoints.tablet} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }

  @media ${breakpoints.laptop} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }
`

const Dash = styled.div`
  width: 23px;
  height: 1px;
  margin-right: 12px;
  background-color: ${colors.mediumGray};
`

interface MediaWistiaProps {
  autoplayVideo?: boolean
  blockId?: string
  caption?: string
  wistiaVideoId: string
}

const MediaWistia: React.FC<MediaWistiaProps> = ({
  autoplayVideo,
  blockId,
  caption,
  wistiaVideoId,
}) =>
  wistiaVideoId ? (
    <Container $caption={!!caption} id={blockId || undefined}>
      <Content>
        <IFrame
          allow={`${autoplayVideo ? "autoplay; " : ""}fullscreen;`}
          src={`https://fast.wistia.net/embed/iframe/${wistiaVideoId}?videoFoam=true`}
          title={caption ?? "Wistia Video"}
        />
        <script
          async
          src="https://fast.wistia.net/assets/external/E-v1.js"
        ></script>
      </Content>
      {caption && (
        <CaptionWrapper>
          <Dash />
          <Caption>{caption}</Caption>
        </CaptionWrapper>
      )}
    </Container>
  ) : null

export default MediaWistia
